export const getAnalyticsPageType = (path = '') => {
  let pageType = 'content';
  if (path.startsWith('/a/')) {
    pageType = 'audience';
  } else if (path.startsWith('/b/')) {
    pageType = 'category';
  }
  return pageType;
};